// 🧩 ConfiguracionProductos.js
import React, { useState, useEffect } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDoc,
  query,
  where,
  serverTimestamp,
  onSnapshot,
} from "firebase/firestore";
import { FaTrashAlt, FaCog, FaPlus } from "react-icons/fa";
import "./ConfiguracionProductos.css";
import ConfiguracionProductoIndividual from "./ConfiguracionProductoIndividual";
import ActionMenu from "../../comunes/componentes/ActionMenu";

export default function ConfiguracionProductos({ perfil }) {
  const [productos, setProductos] = useState([]);
  const [mostrarOnboarding, setMostrarOnboarding] = useState(false);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [busquedaProducto, setBusquedaProducto] = useState("");

  const limpiarProductosDuplicados = async () => {
  if (!perfil?.clienteId) return;

  const ref = collection(db, "productosBase");
  const snap = await getDocs(
    query(ref, where("clienteId", "==", perfil.clienteId))
  );

  const vistos = new Set();

  for (const docu of snap.docs) {
    const data = docu.data();
    const nombre = (data.nombre || "").trim().toLowerCase();

    if (!nombre) continue;

    if (vistos.has(nombre)) {
      await deleteDoc(doc(db, "productosBase", docu.id));
    } else {
      vistos.add(nombre);
    }
  }
};

  // 🔹 Cargar productos y crear base si no existen
const cargarProductos = async () => {
  try {
    if (!perfil) return;
    if (perfil.rol !== "superadmin") {
      await limpiarProductosDuplicados();
    }

    const ref = collection(db, "productosBase");

    const q =
      perfil.rol === "superadmin"
        ? query(ref)
        : query(ref, where("clienteId", "==", perfil.clienteId));

    const snapshot = await getDocs(q);
    let lista = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));

    if (perfil.rol !== "superadmin" && lista.length === 0) {
      const clienteSaasRef = doc(db, "clientes-saas", perfil.clienteId);
      const clienteSaasSnap = await getDoc(clienteSaasRef);
      const clienteSaasData = clienteSaasSnap.exists()
        ? clienteSaasSnap.data()
        : {};

      if (clienteSaasData.productosBaseInicializados !== true) {
        await crearProductosBase();

        await updateDoc(clienteSaasRef, {
          productosBaseInicializados: true,
        });

        const snapshotRecargado = await getDocs(
          query(ref, where("clienteId", "==", perfil.clienteId))
        );

        lista = snapshotRecargado.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        if (lista.length > 0) {
          setMostrarOnboarding(true);
        }
      }
    }

    setProductos(lista);
  } catch (error) {
    console.error("Error al cargar productos:", error);
  }
};

const escucharProductos = () => {
  if (!perfil) return () => {};

  const ref = collection(db, "productosBase");

  const q =
    perfil.rol === "superadmin"
      ? query(ref)
      : query(ref, where("clienteId", "==", perfil.clienteId));

  return onSnapshot(
    q,
    (snapshot) => {
      const lista = snapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      setProductos(lista);
    },
    (error) => {
      console.error("Error escuchando productos:", error);
    }
  );
};
  

  // 🧩 Crear productos por defecto (Remera y Taza)
  const crearProductosBase = async () => {
    try {
      if (!perfil?.clienteId) return;

      const ref = collection(db, "productosBase");

      const existentesSnap = await getDocs(
        query(ref, where("clienteId", "==", perfil.clienteId))
      );

      const nombresExistentes = existentesSnap.docs.map((d) =>
        (d.data().nombre || "").trim().toLowerCase()
      );

      const productosBase = [
        {
          nombre: "Remera",
          tipo: "textil",
          clienteId: perfil.clienteId,
          switches: {
            talles: true,
            colores: true,
            zonas: true,
            imagenes: true,
            atributosExtra: false,
          },
          zonas: {
            Frente: ["F1", "F2", "F3", "F4"],
            Espalda: ["E1", "E2"],
            Mangas: ["M1", "M2"],
          },
          talles: ["XS", "S", "M", "L", "XL", "XXL"],
        },
        {
          nombre: "Taza",
          tipo: "merchandising",
          clienteId: perfil.clienteId,
          switches: {
            talles: false,
            colores: true,
            zonas: true,
            imagenes: true,
            atributosExtra: false,
          },
          zonas: {
            General: ["Zona única"],
          },
        },
      ];

      for (const p of productosBase) {
        const nombreNormalizado = p.nombre.trim().toLowerCase();

        if (!nombresExistentes.includes(nombreNormalizado)) {
          await addDoc(ref, p);
        }
      }

      localStorage.setItem(`productosBaseCreados_${perfil.clienteId}`, "true");
    } catch (error) {
      console.error("Error al crear productos base:", error);
    }
  };

useEffect(() => {
  if (!perfil) return;

  cargarProductos();

  const unsubscribe = escucharProductos();

  return () => unsubscribe();
}, [perfil]);

  const renombrarProducto = async (producto) => {
  const nombreActual = producto?.nombre || "";
  const nuevoNombre = prompt("Nuevo nombre del producto:", nombreActual);

  if (nuevoNombre === null) return;

  const nombreLimpio = nuevoNombre.trim();

  if (!nombreLimpio) {
    alert("El nombre no puede estar vacío.");
    return;
  }

  const yaExiste = productos.some(
    (p) =>
      p.id !== producto.id &&
      (p.nombre || "").trim().toLowerCase() === nombreLimpio.toLowerCase()
  );

  if (yaExiste) {
    alert("Ya existe un producto con ese nombre.");
    return;
  }

  await updateDoc(doc(db, "productosBase", producto.id), {
    nombre: nombreLimpio,
    updatedAt: serverTimestamp(),
  });

};

const duplicarProducto = async (producto) => {
  if (!producto?.id) return;

  const nombreSugerido = `${producto.nombre || "Producto"} copia`;
  const nuevoNombre = prompt("Nombre del producto duplicado:", nombreSugerido);

  if (nuevoNombre === null) return;

  const nombreLimpio = nuevoNombre.trim();

  if (!nombreLimpio) {
    alert("El nombre no puede estar vacío.");
    return;
  }

  const yaExiste = productos.some(
    (p) =>
      (p.nombre || "").trim().toLowerCase() === nombreLimpio.toLowerCase()
  );

  if (yaExiste) {
    alert("Ya existe un producto con ese nombre.");
    return;
  }

  const { id, createdAt, updatedAt, ...datosProducto } = producto;

  await addDoc(collection(db, "productosBase"), {
    ...datosProducto,
    nombre: nombreLimpio,
    clienteId: perfil?.clienteId || producto.clienteId || "",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

 
};

  // 🔹 Eliminar producto
  const eliminarProducto = async (id) => {
    if (window.confirm("¿Seguro que querés eliminar este producto?")) {
      await deleteDoc(doc(db, "productosBase", id));
      
    }
  };

  // 🔹 Crear nuevo producto
  const crearNuevoProducto = async () => {
    const nombre = prompt("Nombre del nuevo producto:");
    if (!nombre) return;

    if (!perfil?.clienteId && perfil?.rol !== "superadmin") {
      alert("No se encontró el clienteId del usuario.");
      return;
    }

    const ref = collection(db, "productosBase");

    await addDoc(ref, {
      nombre,
      tipo: "personalizado",
      clienteId: perfil?.clienteId || "",
      switches: {
        talles: false,
        colores: false,
        zonas: false,
        imagenes: false,
        atributosExtra: false,
      },
    });

    
  };

  // 🔹 Abrir configuración individual
  const abrirConfiguracionProducto = (id) => {
    setProductoSeleccionado(id);
  };

  // 🔹 Volver al listado
  const volverAlListado = () => {
    setProductoSeleccionado(null);
    cargarProductos();
  };

  // 🩵 Mostrar onboarding solo si es la primera vez
  const mostrarMensajeInicial = mostrarOnboarding;


  const productosFiltrados = productos.filter((p) =>
    (p.nombre || "").toLowerCase().includes(busquedaProducto.trim().toLowerCase())
  );

  return (
    <div className="config-productos">
      {!productoSeleccionado ? (
        <>
          <h1>Configuración de Productos</h1>

          {mostrarMensajeInicial && (
            <div className="onboarding-banner">
              <strong>💡 ¡Productos base creados!</strong>
              <p>
                Creamos automáticamente <b>Remera</b> y <b>Taza</b> para que empieces
                más rápido. Podés editarlos o agregar nuevos cuando quieras.
              </p>
            </div>
          )}

          <div className="productos-toolbar">
            <input
              className="productos-buscador"
              value={busquedaProducto}
              onChange={(e) => setBusquedaProducto(e.target.value)}
              placeholder="Buscar producto..."
            />

            <button className="btn-nuevo" onClick={crearNuevoProducto}>
              <FaPlus /> Nuevo producto
            </button>
          </div>

          <table className="tabla-config">
            <thead>
              <tr>
                <th>Producto</th>
                <th style={{textAlign:"right"}}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {productosFiltrados.map((p) => (
                <tr key={p.id}>
                  <td>{p.nombre}</td>

                  <td style={{textAlign:"right"}}>
                    <ActionMenu
                      onEditar={() => abrirConfiguracionProducto(p.id)}
                      onRenombrar={() => renombrarProducto(p)}
                      onDuplicar={() => duplicarProducto(p)}
                      onEliminar={() => eliminarProducto(p.id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <ConfiguracionProductoIndividual
          productoId={productoSeleccionado}
          onVolver={volverAlListado}
        />
      )}
    </div>
  );
}
